import {
  kronosCredentialErrors,
  sftpCredentialErrors
} from './sftpFileFeedConfig';


export const LRS_DEFAULT_FILE_NAME_PATTERN = '^Deferral_.+_\\d{8}\\.(csv|txt)(\\.pgp)?$';

export const LRS_DEFAULT_FILE_NAMING_SCHEMA = '{PLAN_ID}_{PAY_DATE}.csv';

export const LRS_DEFAULT_EARNING_LIST_NAME = '401k Earnings List';


const sharedDefaults = () => ({
  companyName: '',
  kronos: { type: '1password_item', '1password_item_path': '' },
  sftp: { type: '1password_item', '1password_item_path': '' },
  emailConfig: {
    emailContacts: [],
    sendSuccessEmails: 'true'
  }
});

export const LRS_IMPORT_DEFAULTS = {
  ...sharedDefaults(),
  planIds: [],
  archiveDirectory: '/archive'
};

export const LRS_EXPORT_DEFAULTS = {
  ...sharedDefaults(),
  clientShortName: '',
  report: {
    retirement: '',
    workers_comp: ''
  }
};

export const parseCommaList = (text) =>
  text
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

function parseConfig(raw, defaults) {
  if (raw == null || raw === '{ }' || raw === '') {
    return JSON.parse(JSON.stringify(defaults));
  }
  return JSON.parse(raw);
}

function generalErrors(values, config) {
  const errors = [];
  if (!values?.jobName?.trim()) errors.push('Job name is required');
  if (!config.companyName?.trim()) errors.push('Company short name is required');
  errors.push(...kronosCredentialErrors(config.kronos || {}));
  errors.push(...sftpCredentialErrors(config.sftp || {}));
  return errors;
}

function scheduleErrors(values) {
  if (values?.runOnSchedule && !values?.schedule?.trim()) {
    return ['Choose a schedule or turn the schedule off'];
  }
  return [];
}

export function validateLrsImport(values) {
  try {
    const config = parseConfig(values?.config, LRS_IMPORT_DEFAULTS);
    const errors = generalErrors(values, config);

    if (!Array.isArray(config.planIds) || config.planIds.length === 0) {
      errors.push('At least one plan ID is required');
    }
    if (config.fileNamePattern) {
      try {
        new RegExp(config.fileNamePattern);
      } catch (e) {
        errors.push('File name pattern is not a valid regular expression');
      }
    }

    errors.push(...scheduleErrors(values));
    return errors;
  } catch (error) {
    return ['Configuration is not valid JSON'];
  }
}

export function validateLrsPayrollExport(values) {
  try {
    const config = parseConfig(values?.config, LRS_EXPORT_DEFAULTS);
    const errors = generalErrors(values, config);

    if (!config.clientShortName?.trim()) errors.push('Client short name is required');
    if (!config.report?.retirement?.trim()) errors.push('Retirement report is required');
    if (!config.report?.workers_comp?.trim()) errors.push('Workers comp report is required');

    const plans = config.plans || [];
    plans.forEach((plan, i) => {
      const row = `Plan ${i + 1}`;
      if (!plan.name?.trim()) errors.push(`${row}: name is required`);
      if (!plan.shortName?.trim()) errors.push(`${row}: short name is required`);
      if (!plan.eins?.length) errors.push(`${row}: at least one EIN is required`);
    });

    const namingSchema = config.fileNamingSchema || LRS_DEFAULT_FILE_NAMING_SCHEMA;
    if (!config.planId?.trim() && plans.length === 0 && namingSchema.includes('{PLAN_ID}')) {
      errors.push('Enter the plan ID, or add the client\'s plans');
    }

    errors.push(...scheduleErrors(values));
    return errors;
  } catch (error) {
    return ['Configuration is not valid JSON'];
  }
}
